import { forwardRef, useImperativeHandle, useRef } from 'react'

import {
	GeneratorFormSection,
	TGeneratorFormSectionProps,
} from '../components/GeneratorFormSection'
import {
	TContentFormHandle,
	TQrContentFormSection,
} from '../contentFormSections'

export type TContentFormSectionProps = Omit<
	TGeneratorFormSectionProps,
	'content'
> & {
	Content: TQrContentFormSection['Content']
}

export const ContentFormSection = forwardRef<
	TContentFormHandle,
	TContentFormSectionProps
>(({ Content, ...props }, ref) => {
	const formRef = useRef<TContentFormHandle>(null)

	useImperativeHandle(
		ref,
		() => ({
			validate: formRef.current?.validate as TContentFormHandle['validate'],
			trigger: (property: string, message: string) => {
				formRef.current?.trigger?.(property, message)
			},
		}),
		[],
	)

	return <GeneratorFormSection {...props} content={<Content ref={formRef} />} />
})

ContentFormSection.displayName = 'ContentFormSection'
